import React, { useState } from 'react'
import { ButtonWrapper, ExplanationText, FileUploadWrapper, LastOrder, RadioGroup } from './style'
import { Button, Dropzone, Spacing, Input } from 'presentation/components'
import axios from 'axios'
import { NOTIFICATION_TYPE, TEN_MB } from '@/utils/constants'
import { download } from '@/utils/functionUtils'
import { pushNotification } from '@/store/modules/notification/actions'
import { useDispatch } from 'react-redux'
import history from '@/services/history'
import { routesNames } from 'presentation/routes/routesNames'

const BrokerImportOrderFile = ({ brokerData, lastOrder, redoOrder, sendFile }) => {
  const dispatch = useDispatch()
  const [howToDoOrder, setHowToDoOrder] = useState(null)
  const [uploadingFile, setUploadingFile] = useState(null)

  function handleDrop(file) {
    if (file.length < 1) return
    setUploadingFile(file[0])
  }

  const downloadFile = async () => {
    const response = await axios({
      url: brokerData.modelFileUrl,
      method: 'GET',
      responseType: 'blob',
    })
    const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
    download(fileUrl, `Modelo de arquivo para pedido de recarga broker ${brokerData.brokerName}.xlsx`)
  }

  const handleReturnClick = () => {
    history.push(routesNames.recharges.base)
  }

  const handleContinueClick = () => {
    if (!howToDoOrder) {
      dispatch(
        pushNotification({
          type: NOTIFICATION_TYPE.WARNING,
          content: 'Para prosseguir selecione um método de execução do pedido.',
        }),
      )
      return
    }
    if (howToDoOrder === 'new') {
      if (!uploadingFile) {
        dispatch(
          pushNotification({
            type: NOTIFICATION_TYPE.WARNING,
            content: 'Para prosseguir envie um arquivo de pedido.',
          }),
        )
        return
      }
      const data = new FormData()
      data.append('files', uploadingFile)
      sendFile(data)
    } else if (howToDoOrder === 'last') {
      redoOrder(lastOrder.id)
    }
  }

  const handleRedirect = () => {
    history.push(`/recargas/acompanhamento#orderId="${lastOrder?.id}"`)
  }

  const FileUploadComponent = () => {
    return (
      <FileUploadWrapper>
        <ExplanationText>
          A solicitação da recarga é feita através do arquivo de importação.
          <br />
          Baixe o modelo de arquivo e preencha-o com as informações do pedido.
        </ExplanationText>
        <Spacing top='32px' />
        <Button icon='download' variant='action' style={{ width: '370px', margin: 'auto' }} onClick={downloadFile}>
          Baixar Modelo de Arquivo
        </Button>
        <ExplanationText>Envie o arquivo preenchido abaixo.</ExplanationText>
        <div style={{ padding: '0 10%', margin: '32px 0' }}>
          <Dropzone.Line2
            accept={['.xls', '.xlsx']}
            onDrop={handleDrop}
            formatsLabel='xls, xlsx'
            multiple={false}
            maxSize={TEN_MB}
            uploadingFile={uploadingFile}
          />
        </div>
      </FileUploadWrapper>
    )
  }

  return (
    <>
      <RadioGroup>
        {lastOrder?.code && (
          <label>
            <Input.RadioButton
              name='how-to-do-the-order'
              value='last'
              onChange={(e) => setHowToDoOrder(e.target.value)}
            />
            Utilizar dados do último pedido.
            {howToDoOrder === 'last' && (
              <div style={{ marginTop: 32 }}>
                Ao selecionar esta opção, os dados do pedido{' '}
                <LastOrder onClick={handleRedirect}>{lastOrder.code}</LastOrder> serão reutilizados para o pedido atual.
              </div>
            )}
          </label>
        )}
        <label>
          <Input.RadioButton name='how-to-do-the-order' value='new' onChange={(e) => setHowToDoOrder(e.target.value)} />
          Enviar novo pedido.
        </label>
      </RadioGroup>
      {howToDoOrder === 'new' && <FileUploadComponent />}
      <ButtonWrapper>
        <Button variant='outlined' onClick={handleReturnClick}>
          Voltar
        </Button>
        <Button onClick={handleContinueClick}>Continuar</Button>
      </ButtonWrapper>
    </>
  )
}

export default BrokerImportOrderFile
